import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { ApprovalStepsListI18nTitle, ApprovalStepsListI18nTitleRuleAny } from '../i18n/ApprovalStepsListI18n';
import ApprovalStepsListItem from './ApprovalStepsListItem';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalRules, ApprovalStatus, ApprovalStepStatus } from '../../types';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalStepsList() {
  const approval = useApprovalContext();
  const {
    approvalStatus
  } = approval.meta;
  if (!approval.data) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  const {
    approvalRules
  } = approval.data;
  const {
    approvalType,
    approvalAction
  } = approval.meta;
  const getStepStyle = approvalStepStatus => {
    const hasMultipleSteps = approval.data.approvalSteps.length > 1;
    const primaryApproverStyling = hasMultipleSteps ? {
      borderBlockEndStyle: 'dashed',
      borderBlockEndWidth: '100',
      borderBlockEndColor: 'border-core-subtle',
      order: 0,
      paddingBlockEnd: '500'
    } : {
      order: 0
    };
    const secondaryApproverStyling = {
      order: 1
    };
    if (approvalStatus === ApprovalStatus.REJECTED) {
      return approvalStepStatus === ApprovalStepStatus.REJECTED ? primaryApproverStyling : secondaryApproverStyling;
    }
    if (approvalStatus === ApprovalStatus.APPROVED && approvalRules === ApprovalRules.ANY_CAN_APPROVE) {
      return approvalStepStatus === ApprovalStepStatus.APPROVED ? primaryApproverStyling : secondaryApproverStyling;
    }
    return {};
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Paragraph, {
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: approval.data.approvalRules === ApprovalRules.ANY_CAN_APPROVE ? /*#__PURE__*/_jsx(ApprovalStepsListI18nTitleRuleAny, {
          approvalType: approvalType,
          approvalAction: approvalAction
        }) : /*#__PURE__*/_jsx(ApprovalStepsListI18nTitle, {
          approvalType: approvalType,
          approvalAction: approvalAction
        })
      })
    }), /*#__PURE__*/_jsx(TFlex, {
      direction: "column",
      alignItems: "stretch",
      children: approval.data.approvalSteps.map(approvalStep => /*#__PURE__*/_jsx(TFlex, Object.assign({
        marginBlockEnd: "500"
      }, getStepStyle(approvalStep.approvalStepStatus), {
        children: /*#__PURE__*/_jsx(ApprovalStepsListItem, {
          approvalStep: approvalStep
        })
      }), approvalStep.id))
    })]
  });
}
export default ApprovalStepsList;